import AuthRegistrationFooter from "./AuthRegistrationFooter";

export default AuthRegistrationFooter;
